import script from "./Ranking.vue?vue&type=script&setup=true&lang=ts"
export * from "./Ranking.vue?vue&type=script&setup=true&lang=ts"

import "./Ranking.vue?vue&type=style&index=0&id=66ff5690&lang=scss&scoped=true"

import exportComponent from "/Users/alessiomealli/WebstormProjects/switaly/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66ff5690"]])

export default __exports__